import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { FzmarkeListView } from './list-view/fzmarke.list-view';

export const fzmarkeFieldOk: FieldOkConfig = {
  name: 'fzmarke',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{marke}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzmarkeListView,
        sort: {
          properties: [{ property: 'marke', title: 'Marke' }],
        },
      },
    },
  ],
};

export const fzmarkeMultiselectFieldOk: FieldOkConfig = {
  name: 'fzmarke',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{marke}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzmarkeListView,
        sort: {
          properties: [{ property: 'marke', title: 'Marke' }],
        },
      },
    },
  ],
};

export const fzmarkeQueryFieldOk: FieldOkConfig = {
  name: 'fzmarke',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{id}} - {{marke}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: FzmarkeListView,
        sort: {
          properties: [{ property: 'marke', title: 'Marke' }],
        },
      },
    },
  ],
};
